module.exports = __webpack_public_path__ + "static/media/avatar.6a3966fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar.svg
// module id = 92
// module chunks = 0